// Lazy Loading Utilities for Performance Optimization
import { lazy } from 'react';

// Code splitting for heavy components
export const lazyLoadComponent = (importFunc) => {
  return lazy(() => {
    return Promise.all([
      importFunc(),
      new Promise(resolve => setTimeout(resolve, 300)) // Minimum load time for smooth UX
    ]).then(([moduleExports]) => moduleExports);
  });
};

// Preload components on hover/focus
export const preloadComponent = (importFunc) => {
  importFunc();
};

// Lazy load routes
export const LazyDashboard = lazy(() => import('@/pages/Dashboard'));
export const LazyTopPicks = lazy(() => import('@/pages/TopPicks'));
export const LazyDailyDigest = lazy(() => import('@/pages/DailyDigestNew'));
export const LazyStrategyAnalyzer = lazy(() => import('@/pages/StrategyAnalyzer'));
export const LazySentimentAnalysis = lazy(() => import('@/pages/SentimentAnalysis'));
export const LazyBacktesting = lazy(() => import('@/pages/Backtesting'));
export const LazyAlerts = lazy(() => import('@/pages/Alerts'));
export const LazyEnhancedAnalysis = lazy(() => import('@/pages/EnhancedAnalysis'));
